import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskGettingStartedQueuesRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-queues',
	path: '/jira/servicedesk/projects/:projectKey/getting-started/queues/queue-settings',
	exact: true,
};
